/**
 * AddPatient 默认常量 - 当未从字典注入时的兜底数据
 */

import type { OptionItem } from './types';

export const DEFAULT_PATIENT_RELATION: OptionItem[] = [
  { value: '1', label: '本人' },
  { value: '2', label: '配偶' },
  { value: '3', label: '子女' },
  { value: '4', label: '父母' },
  { value: '5', label: '其他' },
];

export const DEFAULT_CERT_TYPE: OptionItem[] = [
  { value: 'I', label: '身份证' },
  { value: 'Q', label: '其他' },
];

export const DEFAULT_GENDER: OptionItem[] = [
  { value: 'M', label: '男' },
  { value: 'F', label: '女' },
];

export const DEFAULT_DISTRICT = {
  name: '北京市-北京市-东城区',
  code: [110000, 110100, 110101],
};
